if (!customElements.get('product-samples')) {
  class ProductSamples extends HTMLElement {
    constructor() {
      super();
      this.listeners();
    }

    listeners() {
      this.querySelectorAll('.js-add-sample').forEach((button) => {
        button.addEventListener('click', () => this.addSampleToBag(button));
      });
    }

    addSampleToBag(button) {
      const variantId = parseInt(button.dataset.variantId);

      button.classList.add('loading');

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then(() => {
          publish(PUB_SUB_EVENTS.cartAdd);
        })
        .finally(() => {
          button.classList.remove('loading');
        });
    }
  }

  customElements.define('product-samples', ProductSamples);
}